import { render, staticRenderFns } from "./userOnline.vue?vue&type=template&id=42023938&scoped=true&"
import script from "./userOnline.vue?vue&type=script&lang=js&"
export * from "./userOnline.vue?vue&type=script&lang=js&"
import style0 from "./userOnline.vue?vue&type=style&index=0&id=42023938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42023938",
  null
  
)

export default component.exports